module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// (webpack)/~/readable-stream/passthrough.js
// module id = 1057
// module chunks = 0